import './bootstrap';
import '../css/app.css';

import { createApp, h } from 'vue';
import { createInertiaApp, router } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';

/* Import Font Awesome */
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faQuestionCircle, faArrowRightFromBracket, faMugHot, faInfoCircle, faThumbsUp, faThumbsDown, faGripLines, faArrowsAlt, faChevronUp, faChevronRight, faPlay, faVolumeMute, faExpand, faVolumeUp, faHome, faCog, faCompress, faRefresh, faArrowDown, faArrowUp, faCheckCircle, faTimes, faUndo, faStar, } from '@fortawesome/free-solid-svg-icons';
import { faStar as faStarRegular, faThumbsUp as farThumbsUp, faThumbsDown as farThumbsDown } from '@fortawesome/free-regular-svg-icons';

library.add(faQuestionCircle, faArrowRightFromBracket, faMugHot, faInfoCircle, faThumbsUp, faThumbsDown, faGripLines, faArrowsAlt, faChevronUp, faChevronRight, faPlay, faVolumeMute, faExpand, faVolumeUp, faHome, faCog, faCompress, faRefresh, faArrowDown, faArrowUp, faCheckCircle, faTimes, faUndo, faStar, faStarRegular, farThumbsUp, farThumbsDown);

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

router.on('navigate', () => {
    if (typeof window._paq !== 'undefined') {
        window._paq.push(['setCustomUrl', window.location.href]);
        window._paq.push(['setDocumentTitle', document.title]);
        window._paq.push(['trackPageView']);
    }
});

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        return createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .component('font-awesome-icon', FontAwesomeIcon)
            .mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});
